/**
 * Genera datos de calificación simulados para los leads
 */

import { Lead } from '@/modules/radar/types';

export const addQualificationData = (leads: Lead[]): Lead[] => {
  return leads.map(lead => {
    // Simular calificación BANT basada en scoring existente
    const score = lead.scoring.total;

    // Criterios BANT simulados
    const budget = score > 60 && lead.scoring.presupuesto > 70;
    const authority = score > 50 && Math.random() > 0.3;
    const need = score > 40 && lead.scoring.zona > 60;
    const timeline = score > 55 && lead.scoring.timing > 50;

    // Lead está calificado si cumple al menos 3 de 4 criterios BANT
    const bantScore = [budget, authority, need, timeline].filter(Boolean).length;
    const qualified = bantScore >= 3;

    // Razón de no calificación
    let reason: string | undefined;
    if (!qualified) {
      if (!budget) reason = 'Presupuesto insuficiente';
      else if (!authority) reason = 'No es decisor';
      else if (!need) reason = 'Necesidad no validada';
      else if (!timeline) reason = 'Timeline indefinido';
      else reason = 'Score general bajo';
    }

    // Determinar si el lead está en proceso de calificación
    // 30% de los leads estarán en proceso (sin procesar aún)
    const inProcess = Math.random() < 0.3 && lead.stage <= 2;

    return {
      ...lead,
      qualification: {
        bant: {
          budget,
          authority,
          need,
          timeline
        },
        score: bantScore,
        qualified,
        reason,
        processed: !inProcess // Si está en proceso, no está procesado
      },
      // Asegurar que leads en proceso tengan progress válido para barras
      progress: inProcess ? Math.max(1, Math.min(99, lead.progress)) : lead.progress
    };
  });
};

export const generateQualificationStats = (leads: Lead[]) => {
  const total = leads.length;
  const qualified = leads.filter(lead => lead.qualification?.qualified).length;
  const inProcess = leads.filter(lead => {
    const score = lead.qualification?.score || 0;
    return !lead.qualification?.qualified && score >= 2;
  }).length;
  const notQualified = total - qualified - inProcess;

  return {
    total,
    qualified,
    inProcess,
    notQualified,
    qualificationRate: total > 0 ? Math.round((qualified / total) * 100) : 0
  };
};